export function scrollSpy() {

    const scrollspy = document.querySelector('.scrollspy');
    let scrollspyItems = scrollspy.querySelectorAll('.scrollspy__item');

    function setActiveScrollspyItem() {
        let currentIndex;
        scrollspyItems.forEach((scrollspyItem, index) => {
            const target = scrollspyItem.getAttribute('href');
            const targetEl = document.querySelector(target);
            if (targetEl) {
                const topOffset = targetEl.getBoundingClientRect().top;
                if (topOffset < 200) {
                    currentIndex = index;
                } else {
                    scrollspyItem.closest('li').classList.remove('active');
                }
            }
        });
        if (currentIndex >= 0) {
            scrollspyItems[currentIndex].closest('li').classList.add('active');
            if (currentIndex > 0) {
                scrollspyItems[currentIndex - 1].closest('li').classList.remove('active');
            }
        }
    }

    window.addEventListener('optimizedScroll', setActiveScrollspyItem);

    return 'scrollSpy';

}
